import type {Series} from '../src/types'

export const srDataTableEls = (series: Series | null, forecastStartDate: string | null) => {
  const randomId = Math.random().toString(36).substring(7)
  const id = `series-table-${randomId}`

  const dataTable = document.createElement('series-table')
  dataTable.setAttribute('series', JSON.stringify(series))
  dataTable.setAttribute('is-time-series', '')
  dataTable.setAttribute('class', 'sr-only')

  if (forecastStartDate) {
    dataTable.setAttribute('forecast-start-date', forecastStartDate)
  }

  const skipToDataTable = document.createElement('a')
  skipToDataTable.setAttribute('href', `#${id}`)
  skipToDataTable.setAttribute('class', 'sr-only')
  skipToDataTable.textContent = 'Skip to end of chart'

  return {dataTable, skipToDataTable}
}
